import {get,post} from 'src/utils/request'

export function login(data){
    return post('/login',data)
}

export function logout(){
    return post('/logout')
}

export function getUserInfo(params){
    return get('/sys/user/selectOne',params)
}

export function updatePassword(data){
    return post('/sys/user/updatePassword',data)
}

export function getSysUserList(params){
    return get('/sys/user/list',params)
}

export function addSysUser(data){
    return post('/sys/user/save',data)
}

export function updateSysUser(data){
    return post('/sys/user/update',data)
}

export function deleteSysUser(data){
    return post('/sys/user/deleteBatch',data)
}

export function getMenuByUserId(params){
    return get('/sys/permission/selectUserMenus',params)
}



